document.addEventListener("DOMContentLoaded", function () {
 // Get the button element
 const backToTopButton = document.getElementById("backtotop-wrapper");

 if(backToTopButton){
  // Show or hide the button depending on scroll position
  window.onscroll = function() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      backToTopButton.classList.add('back-to-top-visible'); // Show the button
    } else {
      backToTopButton.classList.remove('back-to-top-visible'); // Hide the button
    }
  };

  // Scroll to the top smoothly when the button is clicked
  backToTopButton.addEventListener("click", function() {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Smooth scroll
    });
  });
 }
});
